import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/dropdown/new/cmd.jpg';
import galleryImg2 from '../img/envision/dropdown/new/automo.png';
import galleryImgs31 from '../img/envision/dropdown/new/cmd.jpg';
import galleryImg41 from '../img/envision/dropdown/new/cmd.jpg';
import hospital from '../img/envision/socialresponsbilites/sections/different-people-doing-volunteer-work-with-food_23-2149012166.avif';

import grouppepole from '../img/envision/socialresponsbilites/sections/group-volunteers-checking-clothes_1170-1805.jpg';
import enviormentsection from '../img/envision/socialresponsbilites/sections/environmentspects.JPG';
import literacy from '../img/envision/socialresponsbilites/sections/young-girl-cafe-book-reading-coffee_1150-10651.jpg';


const galleryImages = [galleryImg1, galleryImg2];
const galleryImagess = [galleryImgs31, galleryImg41];

const SocialServicessectionone = () => {
    const [currentImage, setCurrentImage] = useState(galleryImages[0]);
    const [currentImages, setCurrentImages] = useState(galleryImagess[0]);

    // Function to cycle through images in galleryImages (first gallery)
    const changeFirstImage = () => {
        setCurrentImage((prevImage) => {
            const currentIndex = galleryImages.indexOf(prevImage);
            return galleryImages[(currentIndex + 1) % galleryImages.length];
        });
    };

    // Function to cycle through images in galleryImagess (second gallery)
    const changeSecondImage = () => {
        setCurrentImages((prevImage) => {
            const currentIndex = galleryImagess.indexOf(prevImage);
            return galleryImagess[(currentIndex + 1) % galleryImagess.length];
        });
    };

    // useEffect for cycling through galleryImages (first image set)
    useEffect(() => {
        const intervalId = setInterval(changeFirstImage, 3000); // Change image every 3 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    // useEffect for cycling through galleryImagess (second image set)
    useEffect(() => {
        const intervalId = setInterval(changeSecondImage, 4000); // Change image every 4 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <section style={{ marginTop: '0px' }}>
            <div className="container">


                <div className="row">
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(28, 29, 29)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                Digital Literacy

                                <span style={{ color: 'rgb(11 130 153)', marginLeft: '5px' }}>
                                    Initiatives
                                </span>
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Across Telangana and Andhra Pradesh, 82 EnvisionDigital Centers are operational, contributing to the Digital India Initiative. These centers have certified over 24,000 adults aged 16 to 60 in L1 and L2 IT literacy. Additionally, more than 13,500 women have received digital literacy training, with over 80% finding these skills useful for accessing e-governance facilities. Furthermore, over 35,000 school children have accessed digital literacy facilities through these centers.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={literacy} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%' }}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <img
                            src={grouppepole} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%' }}
                        />
                    </div>
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(28, 29, 29)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                Empowerment Through

                                <span style={{ color: 'rgb(11 130 153)', marginLeft: '5px' }}>
                                    Skill Development
                                </span>
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Across Telangana and Andhra Pradesh, 82 EnvisionDigital Centers are operational, contributing to the Digital India Initiative. These centers have certified over 24,000 adults aged 16 to 60 in L1 and L2 IT literacy. Additionally, more than 13,500 women have received digital literacy training, with over 80% finding these skills useful for accessing e-governance facilities. Furthermore, over 35,000 school children have accessed digital literacy facilities through these centers.
                                
                                </p>
                            </div>
                        </div>
                    </div>

                </div>


                <div className="row">
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(28, 29, 29)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                Healthcare and Community

                                <span style={{ color: 'rgb(11 130 153)', marginLeft: '5px' }}>
                                    Development
                                </span>
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Across Telangana and Andhra Pradesh, 82 EnvisionDigital Centers are operational, contributing to the Digital India Initiative. These centers have certified over 24,000 adults aged 16 to 60 in L1 and L2 IT literacy. Additionally, more than 13,500 women have received digital literacy training, with over 80% finding these skills useful for accessing e-governance facilities. Furthermore, over 35,000 school children have accessed digital literacy facilities through these centers.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={hospital} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%' }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <img
                            src={enviormentsection} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%' }}
                        />
                    </div>
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(28, 29, 29)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                Environmental and Sustainability 

                                <span style={{ color: 'rgb(11 130 153)', marginLeft: '5px' }}>
                                Initiatives
                                </span>
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                In Hyderabad, 40,471 square meters of neglected government land has been transformed into a park, and 78,000 sq ft of school rooftops now feature rainwater catchments. As part of the Telangana Harithaharam (Go Green) initiative, over 91,000 plant saplings have been planted, achieving an impressive 86.2% survival rate over the past seven years. This green effort involved collaboration from EnvisionCSR volunteers, students from Drebcon-adopted schools, EnvisionDigital Centers, and trainees from EnvisionSkill Centers.
                                
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default SocialServicessectionone;
